import Cookies from "js-cookie";
import i18nIsoCountries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import RolesAccess from "../enums/roles";
import StatusPermohonanRegistrasi from "../enums/statusRegistrasi";
import { format } from "date-fns";
import toast from "react-hot-toast";
import { month } from "../enums/month";

// Register English locale
i18nIsoCountries.registerLocale(enLocale);

export const isResponseErrorObject = (response) => typeof response === "object" && response !== null && !Array.isArray(response);

export const dirtyInput = (dirtyFields, data) =>
  Object.keys(dirtyFields).reduce((acc, key) => {
    acc[key] = data[key];
    return acc;
  }, {});

export function formattedDate(date) {
  if (!date) return "-";
  const initDate = new Date(date);
  // Periksa apakah initDate adalah tanggal valid
  if (isNaN(initDate.getTime())) {
    return "-";
  }
  const format = new Intl.DateTimeFormat("id-ID", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(initDate);
  return format;
}

export const calculateReportProgressDuration = (history, isApproved) => {
  // Cek apakah history ada dan memiliki data
  if (!history || history.length === 0) return "-";

  // Temukan tanggal pengajuan awal
  const start = history.PenyimpananB3History.find((item) => item.statusPengajuan === "Pending")?.tanggalPengajuan ?? history.createdAt;

  // Tentukan tanggal akhir (tanggal penyelesaian jika disetujui, atau saat ini jika belum disetujui)
  const end = isApproved ? history.PenyimpananB3History.find((item) => item.statusPengajuan === "Approved" || item.statusPengajuan === "Rejected")?.tanggalPenyelesaian : Date.now();

  // Jika tanggal pengajuan awal tidak ditemukan, kembalikan '-'
  if (!start) return "-";

  // Konversi tanggal ke timestamp (milidetik)
  const startDate = new Date(start).getTime();
  const endDate = isApproved ? new Date(end).getTime() : end;

  // Jika parsing tanggal gagal (hasilnya NaN), kembalikan '-'
  if (isNaN(startDate) || isNaN(endDate)) return "-";

  // Hitung durasi dalam hari
  const duration = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24));

  // Jika durasi kurang dari 0 (error perhitungan), kembalikan '-'
  return duration >= 0 ? duration : "-";
};

export function calculateNoticationProcessingDays(statusHistory) {
  if (!statusHistory || statusHistory.length === 0) {
    return 0; // Tidak ada data
  }

  // Urutkan statusHistory berdasarkan tanggal perubahan (jika belum diurutkan)
  statusHistory.sort((a, b) => new Date(a.tanggalPerubahan) - new Date(b.tanggalPerubahan));

  // Ambil tanggal awal
  const startDate = new Date(statusHistory[0].tanggalPerubahan);

  let endDate = null;

  // Cari tanggal akhir (status Selesai atau Dibatalkan)
  for (let i = 0; i < statusHistory.length; i++) {
    const status = statusHistory[i];
    if (status.newStatus === "Selesai" || status.newStatus === "Dibatalkan") {
      endDate = new Date(status.tanggalPerubahan);
      break;
    }
  }

  // Jika tidak ada status Selesai atau Dibatalkan, gunakan tanggal hari ini
  if (!endDate) {
    endDate = new Date(); // Menggunakan tanggal hari ini
  }

  // Normalisasi tanggal ke tengah malam (menghindari perhitungan waktu parsial)
  const startDay = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  const endDay = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
  console.log(startDay, endDay);
  // Hitung selisih hari
  const processingDays = Math.floor((endDay - startDay) / (1000 * 60 * 60 * 24));

  return processingDays;
}

export function calculateRegistrasiRekomendasiProcessingDays(statusHistory) {
  if (!statusHistory || statusHistory.length === 0) {
    return 0; // Tidak ada data
  }

  // Urutkan statusHistory berdasarkan tanggal perubahan (jika belum diurutkan)
  statusHistory.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

  // Ambil tanggal awal
  const startDate = new Date(statusHistory[0].createdAt);

  let endDate = null;
  // Cari tanggal akhir (status Selesai atau Dibatalkan)
  for (let i = 0; i < statusHistory.length; i++) {
    const status = statusHistory[i];

    if (status.newStatus === StatusPermohonanRegistrasi.VERIFIKASI_TEKNIS) {
      startDate = new Date(status.createdAt);
      break;
    }

    if (status.newStatus === StatusPermohonanRegistrasi.SELESAI || status.newStatus === StatusPermohonanRegistrasi.DITOLAK) {
      endDate = new Date(status.createdAt);
      break;
    }
  }

  // Jika tidak ada status Selesai atau Dibatalkan, gunakan tanggal hari ini
  if (!endDate) {
    endDate = new Date(); // Menggunakan tanggal hari ini
  }

  // Normalisasi tanggal ke tengah malam (menghindari perhitungan waktu parsial)
  const startDay = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  const endDay = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

  // Hitung selisih hari
  const processingDays = Math.floor((endDay - startDay) / (1000 * 60 * 60 * 24));

  return processingDays;
}

export function calculateRegistrasiRekomendasiProcessingDaysWithTanggalPengajuan(tglPengajuan, tglSelesai) {
  if (!tglPengajuan) return 0;

  const startDate = new Date(tglPengajuan);
  const endDate = tglSelesai ? new Date(tglSelesai) : new Date(); // Gunakan date now jika tglSelesai null

  // Validasi tanggal
  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
    return 0;
  }

  // Normalisasi tanggal ke tengah malam (menghindari perhitungan waktu parsial)
  const startDay = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  const endDay = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

  // Hitung selisih hari
  const processingDays = Math.ceil((endDay - startDay) / (1000 * 60 * 60 * 24));

  // Pastikan tidak negatif
  return Math.max(0, processingDays);
}

export function calculateRekomendasiProcessingDays(statusHistory) {
  if (!statusHistory || statusHistory.length === 0) {
    return 0; // Tidak ada data
  }

  // Urutkan statusHistory berdasarkan tanggal perubahan (jika belum diurutkan)
  statusHistory.sort((a, b) => new Date(a.changedAt) - new Date(b.changedAt));

  // Ambil tanggal awal
  let startDate = new Date(statusHistory[0].changedAt);

  let endDate = null;
  // Cari tanggal akhir (status Selesai atau Dibatalkan)
  for (let i = 0; i < statusHistory.length; i++) {
    const status = statusHistory[i];

    if (status.newStatus === StatusPermohonanRegistrasi.VERIFIKASI_TEKNIS) {
      startDate = new Date(status.changedAt);
      break;
    }

    if (status.newStatus === StatusPermohonanRegistrasi.SELESAI || status.newStatus === StatusPermohonanRegistrasi.DITOLAK) {
      endDate = new Date(status.changedAt);
      break;
    }
  }

  // Jika tidak ada status Selesai atau Dibatalkan, gunakan tanggal hari ini
  if (!endDate) {
    endDate = new Date(); // Menggunakan tanggal hari ini
  }

  // Normalisasi tanggal ke tengah malam (menghindari perhitungan waktu parsial)
  const startDay = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
  const endDay = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

  // Hitung selisih hari
  const processingDays = Math.floor((endDay - startDay) / (1000 * 60 * 60 * 24));

  return processingDays;
}

export function diffForHuman(datePast, dateCurrent) {
  const current = new Date(dateCurrent);
  const past = new Date(datePast);
  const diffMs = current - past; // Difference in milliseconds
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffDays / 365);

  if (diffSeconds < 60) return `${diffSeconds} detik`;
  if (diffMinutes < 60) return `${diffMinutes} menit `;
  if (diffHours < 24) return `${diffHours} jam `;
  if (diffDays < 7) return `${diffDays} hari`;
  if (diffWeeks < 4) return `${diffWeeks} minggu `;
  if (diffMonths < 12) return `${diffMonths} bulan `;

  return `${diffYears} tahun`;
}

export const getCountryName = (countryCode, locale = "en", options = {}) => {
  try {
    let country = i18nIsoCountries.getName(countryCode, locale, options);
    console.log(country);
    return country;
  } catch (error) {
    console.error(`Error fetching country name for ${countryCode}:`, error);
    return null;
  }
};

export const formDataWithParsedLocation = (data) => ({
  ...data,
  ...(data.asalMuat && {
    asalMuat: data.asalMuat.map((item) => ({
      ...item,
      latitude: parseFloat(item.latitude),
      longitude: parseFloat(item.longitude),
    })),
  }),
  ...(data.tujuanBongkar && {
    tujuanBongkar: data.tujuanBongkar.map((item) => ({
      ...item,
      latitude: parseFloat(item.latitude),
      longitude: parseFloat(item.longitude),
    })),
  }),
});

export function getRoles() {
  const getRole = Cookies.get("roles");
  return getRole;
}

export function removeSlug(slug) {
  var words = slug.split("-");

  for (var i = 0; i < words.length; i++) {
    var word = words[i];
    words[i] = word.charAt(0).toUpperCase() + word.slice(1);
  }

  return words.join(" ");
}

// Array nama bulan
export const monthNames = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

export const translateMonth = (month) => {
  const months = [
    null, // Indeks 0 tidak digunakan karena bulan dimulai dari 1
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];

  // Pastikan input berupa string atau angka
  const parsedMonth = parseInt(month, 10);

  // Validasi indeks bulan (1 hingga 12)
  if (parsedMonth >= 1 && parsedMonth <= 12) {
    return months[parsedMonth];
  }

  return "Bulan tidak valid";
};

export function hasValidRole(userRoles, validRoles) {
  return validRoles.some((role) => userRoles.includes(role));
}

export function isSuperAdminRole(userRoles) {
  const validRoles = [RolesAccess.SUPER_ADMIN];
  return validRoles.some((role) => userRoles.includes(role));
}

export function hasValidStatus(currentStatus, validStatus) {
  if (!Array.isArray(currentStatus)) {
    currentStatus = [currentStatus];
  }
  return validStatus.some((status) => currentStatus.includes(status));
}

export function calculatePeriodMonthAndYear(periodId, dataPeriod, setAvailableYears, setAvailableMonths) {
  if (periodId) {
    const selectedPeriod = dataPeriod && Array.isArray(dataPeriod?.data) ? dataPeriod?.data?.find((period) => period.id === periodId) : null;

    if (selectedPeriod) {
      const startDate = new Date(selectedPeriod.startPeriodDate);
      const endDate = new Date(selectedPeriod.endPeriodDate);

      // Hitung tahun dalam rentang
      const yearsInRange = [];
      for (let year = startDate.getFullYear(); year <= endDate.getFullYear(); year++) {
        yearsInRange.push({ value: year, label: String(year) }); // Tambahkan model {value, label}
      }
      setAvailableYears(yearsInRange);

      // Hitung bulan dalam rentang
      let monthsInRange = [];
      if (startDate.getFullYear() === endDate.getFullYear()) {
        // Jika tahun yang sama
        monthsInRange = month.slice(startDate.getMonth(), endDate.getMonth() + 1).map((name, index) => ({
          value: startDate.getMonth() + index + 1,
          label: name,
        }));
      } else {
        // Jika tahun berbeda, ambil semua bulan
        monthsInRange = month.map((name, index) => ({
          value: index + 1,
          label: name,
        }));
      }
      setAvailableMonths(monthsInRange);
    } else {
      setAvailableYears([]);
      setAvailableMonths([]);
    }
  } else {
    setAvailableYears([]);
    setAvailableMonths([]);
  }
}

export function toDecimalDegrees(coord) {
  // If the input is already a number, return it as is (Decimal Degrees format)
  if (typeof coord === "number") {
    return coord;
  }

  // Match DMS or DDM format
  const regex = /^([NSWE])?\s?(\d+)[°:]?(\d+)?[':]?([\d.,]+)?"?$/i;
  const match = coord.match(regex);

  if (!match) {
    throw new Error(`Invalid coordinate format: ${coord}`);
  }

  const [direction, degrees, minutes, seconds] = match;

  // Convert degrees, minutes, seconds to decimal
  const decimalDegrees = parseFloat(degrees) + parseFloat(minutes || 0) / 60 + parseFloat((seconds || "0").replace(",", ".")) / 3600;

  // Apply negative sign for South or West
  if (direction && ["S", "W"].includes(direction.toUpperCase())) {
    return -decimalDegrees;
  }

  return decimalDegrees;
}

export function convertLatLonToDecimal(latitude, longitude) {
  const y = toDecimalDegrees(latitude);
  const x = toDecimalDegrees(longitude);

  return { x, y };
}

export function filteredMaterialData(data, isLoading) {
  const groupedData = data?.data?.reduce((acc, item) => {
    const { dataBahanB3Id, dataBahanB3 } = item;
    if (!acc[dataBahanB3Id]) {
      acc[dataBahanB3Id] = dataBahanB3;
    }
    return acc;
  }, {});

  const resultArray = !isLoading && data ? Object.values(groupedData) : [];
  return resultArray;
}

export function groupedVehicle(data, isLoading) {
  const groupedData = data?.data?.reduce((acc, item) => {
    const { vehicleId, vehicle } = item;
    if (!acc[vehicleId]) {
      acc[vehicleId] = vehicle;
    }
    return acc;
  }, {});

  const resultArray = !isLoading && data ? Object.values(groupedData) : [];
  return resultArray;
}

/*
 * Fungsi ini dipanggil SAAT RENDER oleh pemanggilnya, jadi tidak boleh memicu
 * efek samping. Versi sebelumnya memanggil toast.error() di sini, dan itu
 * memperbarui komponen Toaster di tengah render komponen lain - React
 * mengeluarkan peringatan "Cannot update a component while rendering a
 * different component".
 *
 * Selama ini tidak terlihat karena request-nya baru berjalan setelah pengguna
 * memilih perusahaan; begitu perusahaan terisi otomatis, respons "tidak ada
 * data" langsung datang saat render pertama dan peringatannya muncul.
 *
 * Penyampaian pesannya diserahkan ke pemanggil lewat useEffect.
 */
export function groupedTransportDataByVehicle(data, isLoading) {
  if (data?.message) {
    return undefined;
  }
  const groupedData = data?.preview?.reduce((acc, current) => {
    const vehicleId = current.vehicle.id;

    if (!acc[vehicleId]) {
      acc[vehicleId] = {
        vehicle: current.vehicle,
        bahanB3: [],
        totalJumlahB3: 0,
      };
    }

    // Add bahanB3 data
    acc[vehicleId].bahanB3.push(...current.bahanB3);

    // Sum jumlahB3 for the vehicle
    current.bahanB3.forEach((bahan) => {
      acc[vehicleId].totalJumlahB3 += bahan.jumlahB3;
    });

    return acc;
  }, {});

  const resultArray = data && !isLoading ? Object.values(groupedData) : null;
  return resultArray;
}

export function filteredMaterialDataReportProduction(data, isLoading) {
  const groupedData = data?.data?.reduce((acc, item) => {
    const { dataBahanB3Id, dataBahanB3, namaProduk } = item;
    if (dataBahanB3Id) {
      acc[dataBahanB3Id] = {
        id: dataBahanB3.id,
        namaBahanKimia: dataBahanB3.namaBahanKimia,
        casNumber: dataBahanB3.casNumber,
        namaDagang: dataBahanB3.namaDagang,
      };
    } else if (dataBahanB3Id === null) {
      acc[namaProduk] = {
        id: namaProduk,
        namaBahanKimia: namaProduk,
        casNumber: "-",
        namaDagang: "-",
      };
    }
    return acc;
  }, {});
  const resultArray = !isLoading && data ? Object.values(groupedData) : [];
  return resultArray;
}

export function filteredMaterialDataReportPurchase(data, isLoading) {
  const groupedData = data?.data?.reduce((acc, item) => {
    const { registrasiId, registrasi, dataBahanB3Id, dataBahanB3, tipePembelian, no_surat_registrasi, supplierCompany } = item;
    const kunci = registrasiId ?? dataBahanB3Id;
    if (!kunci) return acc;

    if (!acc[kunci]) {
      acc[kunci] = {
        id: registrasiId ? registrasi?.id : dataBahanB3Id,
        noRegistrasi: registrasiId ? registrasi?.nomor_surat_formatted ?? registrasi?.nomorSurat : tipePembelian === "Lokal" ? no_surat_registrasi : "-",
        namaBahanKimia: dataBahanB3?.namaBahanKimia,
        casNumber: dataBahanB3?.casNumber,
        namaDagang: dataBahanB3?.namaDagang,
        // Dikumpulkan sebagai himpunan, bukan diambil dari baris terakhir:
        // satu kartu mewakili seluruh bulan, dan bulan-bulan itu bisa saja
        // tercatat dengan pemasok yang berbeda. Menampilkan salah satunya saja
        // membuat kartu tampak memastikan hal yang tidak dipastikan datanya.
        daftarTipePembelian: new Set(),
        daftarPemasok: new Set(),
      };
    }

    // Ejaan "Import" dan "Impor" hidup berdampingan di basis data untuk hal
    // yang sama - disamakan supaya kartu tidak menampilkan keduanya sekaligus.
    if (tipePembelian) {
      acc[kunci].daftarTipePembelian.add(/^impor(t)?$/i.test(tipePembelian.trim()) ? "Impor" : tipePembelian.trim());
    }
    if (supplierCompany?.name) acc[kunci].daftarPemasok.add(supplierCompany.name);

    return acc;
  }, {});

  if (isLoading || !data) return [];

  return Object.values(groupedData ?? {}).map(({ daftarTipePembelian, daftarPemasok, ...bahan }) => ({
    ...bahan,
    tipePembelian: Array.from(daftarTipePembelian).join(", "),
    pemasok: Array.from(daftarPemasok).join(", "),
  }));
}

export const groupDataByPerusahaanAsalMuatId = (pengangkutanDetails) => {
  const groupedData = {};

  pengangkutanDetails.DataPerusahaanTujuanBongkarOnPengakutanDetail.forEach((item) => {
    const perusahaanAsalMuatId = item.perusahaanAsalMuatId;

    if (!groupedData[perusahaanAsalMuatId]) {
      groupedData[perusahaanAsalMuatId] = {
        perusahaanAsalMuat: item.perusahaanAsalMuat,
        perusahaanTujuanBongkar: [],
      };
    }

    groupedData[perusahaanAsalMuatId].perusahaanTujuanBongkar.push({
      ...item.perusahaanTujuanBongkar,
      jumlahDiAngkut: item.jumlahDiAngkut,
      jumlahDiBongkar: item.jumlahDiBongkar,
      locationTypeTujuan: item.locationTypeTujuan,
      longitudeTujuan: item.longitudeTujuan,
      latitudeTujuan: item.latitudeTujuan,
    });
  });

  return Object.values(groupedData || {});
};

export function formatDate(value) {
  // Check if value is a valid date
  const date = value instanceof Date ? value : new Date(value);
  if (isNaN(date)) {
    return ""; // Return empty string if not a valid date
  }
  return format(date, "yyyy-MM-dd");
}

export const allProvinces = [
  {
    name: "Aceh",
    mapCode: "ID-AC",
    coordinates: [
      [
        [95.0, 5.5],
        [95.4, 5.8],
        [96.0, 5.6],
        [95.0, 5.5],
      ],
    ],
  },
  {
    name: "Sumatra Utara",
    mapCode: "ID-SU",
    coordinates: [
      [
        [98.5, 3.0],
        [99.0, 3.2],
        [99.5, 3.0],
        [98.5, 3.0],
      ],
    ],
  },
  {
    name: "Sumatra Barat",
    mapCode: "ID-SB",
    coordinates: [
      [
        [100.0, -1.0],
        [100.4, -1.2],
        [100.8, -1.0],
        [100.0, -1.0],
      ],
    ],
  },
  {
    name: "Riau",
    mapCode: "ID-RI",
    coordinates: [
      [
        [101.0, 0.5],
        [101.4, 0.7],
        [101.8, 0.5],
        [101.0, 0.5],
      ],
    ],
  },
  {
    name: "Kepulauan Riau",
    mapCode: "ID-KR",
    coordinates: [
      [
        [104.0, 1.0],
        [104.3, 1.2],
        [104.6, 1.0],
        [104.0, 1.0],
      ],
    ],
  },
  {
    name: "Jambi",
    mapCode: "ID-JA",
    coordinates: [
      [
        [103.0, -1.0],
        [103.3, -1.2],
        [103.6, -1.0],
        [103.0, -1.0],
      ],
    ],
  },
  {
    name: "Sumatra Selatan",
    mapCode: "ID-SS",
    coordinates: [
      [
        [104.0, -2.5],
        [104.4, -2.7],
        [104.8, -2.5],
        [104.0, -2.5],
      ],
    ],
  },
  {
    name: "Bengkulu",
    mapCode: "ID-BE",
    coordinates: [
      [
        [102.0, -3.8],
        [102.3, -4.0],
        [102.7, -3.9],
        [102.0, -3.8],
      ],
    ],
  },
  {
    name: "Lampung",
    mapCode: "ID-LA",
    coordinates: [
      [
        [105.0, -5.0],
        [105.4, -5.2],
        [105.8, -5.0],
        [105.0, -5.0],
      ],
    ],
  },
  {
    name: "Kepulauan Bangka Belitung",
    mapCode: "ID-BB",
    coordinates: [
      [
        [106.0, -2.5],
        [106.4, -2.7],
        [106.8, -2.5],
        [106.0, -2.5],
      ],
    ],
  },
  {
    name: "Banten",
    mapCode: "ID-BT",
    coordinates: [
      [
        [106.0, -6.5],
        [106.3, -6.6],
        [106.7, -6.4],
        [106.0, -6.5],
      ],
    ],
  },
  {
    name: "DKI Jakarta",
    mapCode: "ID-JK",
    coordinates: [
      [
        [106.7, -6.2],
        [106.8, -6.3],
        [106.9, -6.2],
        [106.7, -6.2],
      ],
    ],
  },
  {
    name: "Jawa Barat",
    mapCode: "ID-JB",
    coordinates: [
      [
        [107.0, -6.8],
        [107.2, -6.9],
        [107.5, -6.7],
        [107.0, -6.8],
      ],
    ],
  },
  {
    name: "Jawa Tengah",
    mapCode: "ID-JT",
    coordinates: [
      [
        [
          [108.5, -6.5],
          [109.5, -6.0],
          [110.5, -5.8],
          [112.0, -6.2],
          [112.5, -7.0],
          [112.0, -8.0],
          [110.0, -8.2],
          [109.0, -7.5],
          [108.5, -6.5],
        ],
      ],
    ],
  },
  {
    name: "DI Yogyakarta",
    mapCode: "ID-YO",
    coordinates: [
      [
        [110.2, -7.8],
        [110.4, -7.5],
        [110.6, -7.7],
        [110.2, -7.8],
      ],
    ],
  },
  {
    name: "Jawa Timur",
    mapCode: "ID-JI",
    coordinates: [
      [
        [112.0, -7.5],
        [112.4, -7.7],
        [112.8, -7.5],
        [112.0, -7.5],
      ],
    ],
  },
  {
    name: "Bali",
    mapCode: "ID-BA",
    coordinates: [
      [
        [115.0, -8.0],
        [115.2, -8.1],
        [115.4, -8.0],
        [115.0, -8.0],
      ],
    ],
  },
  {
    name: "Nusa Tenggara Barat",
    mapCode: "ID-NB",
    coordinates: [
      [
        [115.5, -8.0],
        [116.5, -7.5],
        [117.5, -7.5],
        [118.0, -8.0],
        [118.0, -9.0],
        [117.0, -9.5],
        [115.5, -9.0],
        [115.5, -8.0],
      ],
    ],
  },
  {
    name: "Nusa Tenggara Timur",
    mapCode: "ID-NT",
    coordinates: [
      [
        [120.0, -10.0],
        [120.4, -10.2],
        [120.8, -10.0],
        [120.0, -10.0],
      ],
    ],
  },
  {
    name: "Kalimantan Barat",
    mapCode: "ID-KB",
    coordinates: [
      [
        [109.0, 0.5],
        [109.4, 0.6],
        [109.8, 0.5],
        [109.0, 0.5],
      ],
    ],
  },
  {
    name: "Kalimantan Tengah",
    mapCode: "ID-KT",
    coordinates: [
      [
        [113.0, -1.5],
        [113.4, -1.7],
        [113.8, -1.5],
        [113.0, -1.5],
      ],
    ],
  },
  {
    name: "Kalimantan Selatan",
    mapCode: "ID-KS",
    coordinates: [
      [
        [115.0, -2.5],
        [115.4, -2.6],
        [115.8, -2.5],
        [115.0, -2.5],
      ],
    ],
  },
  {
    name: "Kalimantan Timur",
    mapCode: "ID-KI",
    coordinates: [
      [
        [117.0, 0.5],
        [117.4, 0.7],
        [117.8, 0.5],
        [117.0, 0.5],
      ],
    ],
  },
  {
    name: "Kalimantan Utara",
    mapCode: "ID-KU",
    coordinates: [
      [
        [117.5, 3.0],
        [118.0, 3.2],
        [118.5, 3.0],
        [117.5, 3.0],
      ],
    ],
  },
  {
    name: "Sulawesi Utara",
    mapCode: "ID-SA",
    coordinates: [
      [
        [123.0, 0.0],
        [124.5, 1.0],
        [125.5, 1.5],
        [126.5, 2.0],
        [127.0, 4.0],
        [126.0, 4.5],
        [125.0, 4.0],
        [123.5, 3.0],
        [122.5, 1.5],
        [123.0, 0.0],
      ],
      [
        [126.5, 3.5],
        [127.5, 4.0],
        [128.0, 4.5],
        [127.5, 5.0],
        [126.5, 4.5],
        [126.5, 3.5],
      ],
    ],
  },
  {
    name: "Sulawesi Tengah",
    mapCode: "ID-ST",
    coordinates: [
      [
        [121.0, -1.0],
        [121.4, -1.2],
        [121.8, -1.0],
        [121.0, -1.0],
      ],
    ],
  },
  {
    name: "Sulawesi Selatan",
    mapCode: "ID-SN",
    coordinates: [
      [
        [120.0, -5.0],
        [120.4, -5.2],
        [120.8, -5.0],
        [120.0, -5.0],
      ],
    ],
  },
  {
    name: "Sulawesi Tenggara",
    mapCode: "ID-SG",
    coordinates: [
      [
        [123.0, -4.0],
        [123.4, -4.2],
        [123.8, -4.0],
        [123.0, -4.0],
      ],
    ],
  },
  {
    name: "Sulawesi Barat",
    mapCode: "ID-SR",
    coordinates: [
      [
        [118.0, -2.0],
        [118.4, -2.2],
        [118.8, -2.0],
        [118.0, -2.0],
      ],
    ],
  },
  {
    name: "Gorontalo",
    mapCode: "ID-GO",
    coordinates: [
      [
        [122.0, 0.6],
        [122.3, 0.7],
        [122.5, 0.5],
        [122.0, 0.6],
      ],
    ],
  },
  {
    name: "Maluku",
    mapCode: "ID-MA",
    coordinates: [
      [
        [128.0, -3.0],
        [128.4, -3.2],
        [128.8, -3.0],
        [128.0, -3.0],
      ],
    ],
  },
  {
    name: "Maluku Utara",
    mapCode: "ID-MU",
    coordinates: [
      [
        [126.5, 0.5],
        [127.5, 1.0],
        [128.5, 2.0],
        [129.0, 2.5],
        [128.0, 1.0],
        [127.0, 0.0],
        [126.5, -0.5],
        [126.5, 0.5],
      ],
      [
        [129.5, 2.0],
        [130.0, 2.5],
        [130.5, 3.0],
        [130.0, 3.5],
        [129.5, 3.0],
        [129.5, 2.0],
      ],
    ],
  },
  {
    name: "Papua",
    mapCode: "ID-PA",
    coordinates: [
      [
        [138.0, -5.0],
        [138.4, -5.2],
        [138.8, -5.0],
        [138.0, -5.0],
      ],
    ],
  },
  {
    name: "Papua Barat",
    mapCode: "ID-PB",
    coordinates: [
      [
        [132.0, -1.0],
        [132.4, -1.2],
        [132.8, -1.0],
        [132.0, -1.0],
      ],
    ],
  },
];

// Fungsi untuk memformat tanggal ke dd-MM-yyyy
export const formatToDate = (date) => {
  const d = new Date(date);
  const day = d.getDate().toString().padStart(2, "0");
  const month = (d.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-indexed
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

export const filterValidRows = (rows, requiredFields) => {
  return rows
    .map((row, index) =>
      requiredFields.reduce(
        (acc, field, colIndex) => {
          acc[field] = row[colIndex] || "-";
          return acc;
        },
        { id: `${requiredFields[0]}_${index + 1}` }
      )
    )
    .filter((row) => requiredFields.every((field) => row[field] !== "-"));
};

/**
 * Isi kolom alamat dan lokasi sebuah form dari data perusahaan terpilih.
 *
 * Dipakai modal Asal Muat dan Tujuan Bongkar: begitu perusahaan dipilih, kolom
 * di bawahnya terisi dari master perusahaan supaya tidak diketik ulang.
 *
 * locationType SENGAJA tidak diisi - Factory / Gudang / Pelabuhan menerangkan
 * jenis lokasi muat-bongkarnya, bukan data perusahaan, jadi tetap dipilih
 * manual.
 *
 * Nilai yang kosong ditulis sebagai string kosong, bukan dilewati, supaya sisa
 * isian perusahaan sebelumnya tidak tertinggal di form.
 */
export function isiKolomDariPerusahaan(setValue, perusahaan) {
    if (typeof setValue !== 'function') return;

    const p = perusahaan || {};
    setValue('alamat', p.alamatKantor ?? '');
    setValue('latitude', p.latitude ?? '');
    setValue('longitude', p.longitude ?? '');
    setValue('provinceId', p.provinceId ?? '');
    setValue('regencyId', p.regencyId ?? '');
    setValue('districtId', p.districtId ?? '');
    setValue('villageId', p.villageId ?? '');
}

/**
 * Bentuk baku sebuah nomor CAS, atau null bila bukan nomor CAS yang sah.
 *
 * Kembaran dari normalisasiNomorCas di api/src/utils/helpers.ts - aturannya
 * HARUS sama, sebab yang dicocokkan di sini (bahan B3 pada SK terhadap data
 * master) adalah pasangan yang sama dengan yang dicocokkan backend saat membuat
 * laporan. Kalau keduanya berbeda, pengguna bisa memilih bahan yang ternyata
 * ditolak backend, atau sebaliknya.
 *
 * Angka periksa adalah penjaganya: salah ketik seperti "64-56-1" (Metanol,
 * seharusnya 67-56-1) ditolak, bukan dipetakan diam-diam ke zat lain.
 */
const ALIAS_CAS_SALAH_CETAK = {
    // 109-99-1 dicetak PP 74/2001 Lampiran I No. 125 untuk Tetrahidrofuran dan
    // terlanjur menyebar ke dokumen registrasi. Nomor yang sah 109-99-9.
    '109-99-1': '109-99-9',
};

export function normalisasiNomorCas(nilai) {
    if (!nilai) return null;

    const tanpaSpasi = nilai.toString().replace(/\s+/g, '');
    if (ALIAS_CAS_SALAH_CETAK[tanpaSpasi]) return ALIAS_CAS_SALAH_CETAK[tanpaSpasi];

    const angka = nilai.toString().replace(/\D/g, '').replace(/^0+/, '');
    // Nomor CAS terpendek berbentuk 2-2-1 digit, terpanjang 7-2-1.
    if (angka.length < 5 || angka.length > 10) return null;

    const periksa = Number(angka.slice(-1));
    const tengah = angka.slice(-3, -1);
    const awal = angka.slice(0, -3);

    const jumlah = angka
        .slice(0, -1)
        .split('')
        .reverse()
        .reduce((total, digit, indeks) => total + Number(digit) * (indeks + 1), 0);

    if (jumlah % 10 !== periksa) return null;

    return `${awal}-${tengah}-${periksa}`;
}

/**
 * Cari satu baris master bahan B3 berdasarkan nomor CAS milik bahan pada SK.
 * Dicoba persis lebih dulu, baru bentuk bakunya - gaya penulisan yang berbeda
 * ("007782-50-5", "7664939") tidak boleh membuat bahan yang ada dianggap hilang.
 */
export function cariBahanB3DariCas(daftarMaster, casNumber) {
    if (!Array.isArray(daftarMaster) || !casNumber) return null;

    const dicari = casNumber.toString().replace(/\s+/g, '').toLowerCase();
    const persis = daftarMaster.find(
        (item) => (item?.casNumber ?? '').toString().replace(/\s+/g, '').toLowerCase() === dicari,
    );
    if (persis) return persis;

    const baku = normalisasiNomorCas(casNumber);
    if (!baku) return null;

    return (
        daftarMaster.find(
            (item) => (item?.casNumber ?? '').toString().replace(/\s+/g, '').toLowerCase() === baku.toLowerCase(),
        ) ?? null
    );
}
